import { useNavigate } from "react-router";
import {
  IIntegrationPartner,
  IpNames,
  UserRole,
} from "../../../interfaces/interfaces";

const handleStep = (step, setStep, ip, setIp) => {
  setStep(step);
  setIp(ip);
};

function getHashFromWindow() {
  // Getting the hash from the window location
  const hash = window.location.hash;

  // Optional: Removing the '#' from the beginning of the hash
  const formattedHash = hash.substring(1);

  return `#${formattedHash}`;
}

const setRedirectObj = (updated = false) => {
  const { pathname, search } = window.location;
  window.localStorage.setItem("isUpdated", JSON.stringify(updated));
  window.localStorage.setItem("RedirectURI", window.location.pathname + search);
  window.localStorage.setItem("RedirectHash", window.location.hash);
  window.localStorage.setItem(
    "RedirectExpiry",
    String(new Date(new Date().getTime() + 5 * 60000).getTime())
  );
};

export default function Integrations(
  ipName,
  ipId,
  user,
  ip,
  step = 1,
  setStep,
  setIp,
  updated = false,
  storeName = ""
) {
  console.log("ipNames", ipName);
  switch (ipName) {
    case IpNames.shopify:
      setRedirectObj(updated);
      window.location.href = `https://apps.shopify.com/merito-unique-insights`;
      return;

    case IpNames.googleAds:
      step != 2 ? handleStep(2, setStep, ip, setIp) : [];
      if (step == 2) {
        setRedirectObj();
        window.location.href = `${
          import.meta.env.VITE_IP_DEV_REST_LOCATION
        }/integrations/google/auth?ipName=${ipName}&ipId=${ipId}&userId=${
          user.id
        }&companyId=${user.companyId}`;
      }
      return;

    case IpNames.googleAnalytics:
      step != 2 ? handleStep(2, setStep, ip, setIp) : [];
      if (step == 2) {
        setRedirectObj();
        window.location.href = `${
          import.meta.env.VITE_IP_DEV_REST_LOCATION
        }/integrations/googleanalytics/auth?ipName=${ipName}&ipId=${ipId}&userId=${
          user.id
        }&companyId=${user.companyId}`;
      }
      return;

    case IpNames.metaAds:
      setRedirectObj();
      window.location.href = `${
        import.meta.env.VITE_IP_DEV_REST_LOCATION
      }/integrations/metaAds/auth?wsName=ipName=${ipName}&ipId=${ipId}&userId=${
        user.id
      }&companyId=${user.companyId}`;
      return;

    case IpNames.amazonSellerCentral:
      step != 2 ? handleStep(2, setStep, ip, setIp) : [];
      if (step == 2) {
        setRedirectObj();

        // CHECK IF VERSION IS BETA
        const version =
          import.meta.env.VITE_AMAZON_SELLER_VERSION == "beta"
            ? "&version=beta"
            : "";

        const state = JSON.stringify({
          ipId: ipId,
          userId: user.id,
          companyId: user.companyId,
        });
        window.location.href = `https://sellercentral.amazon.in/apps/authorize/consent?application_id=${
          import.meta.env.VITE_AMAZON_SELLER_APP_ID
        }${version}&state=${state}&redirect_uri=${
          import.meta.env.VITE_IP_DEV_REST_LOCATION
        }/integrations/amazonSeller/auth/callback`;
      }
      return;
    case IpNames.amazonVendorCentral:
      step != 2 ? handleStep(2, setStep, ip, setIp) : [];
      if (step == 2) {
        setRedirectObj();

        // CHECK IF VERSION IS BETA
        const version =
          import.meta.env.VITE_AMAZON_VENDOR_VERSION == "beta"
            ? "&version=beta"
            : "";

        const state = JSON.stringify({
          ipId: ipId,
          userId: user.id,
          companyId: user.companyId,
        });
        const redirect_uri = `https://www.vendorcentral.in/apps/authorize/consent?application_id=${
          import.meta.env.VITE_AMAZON_VENDOR_APP_ID
        }${version}&state=${state}&redirect_uri=${
          import.meta.env.VITE_IP_DEV_REST_LOCATION
        }/integrations/amazonVendor/auth/callback`;
        console.log(redirect_uri);
        window.location.href = redirect_uri;
      }
      return;
    case IpNames.amazonAds:
      step != 2 ? handleStep(2, setStep, ip, setIp) : [];
      if (step == 2) {
        setRedirectObj();
        window.location.href = `${
          import.meta.env.VITE_IP_DEV_REST_LOCATION
        }/integrations/amazonAds/auth?wsName=ipName=${ipName}&ipId=${ipId}&userId=${
          user.id
        }&companyId=${user.companyId}`;
      }
      return;

    // case IpNames.flipkartSeller:
    //   setRedirectObj();
    //   console.log("ipId", ipId);
    //   window.location.href = `${
    //     import.meta.env.VITE_IP_DEV_REST_LOCATION
    //   }/integrations/flipkart/auth?wsName=ipName=${ipName}&ipId=${ipId}&userId=${
    //     user.id
    //   }&companyId=${user.companyId}${
    //     storeName != "" ? "&storeName=" + storeName : ""
    //   }`;
    //   return;

    case IpNames.flipkartAds:
      setRedirectObj();
      console.log("ipId", ipId);
      window.location.href = `${
        import.meta.env.VITE_IP_DEV_REST_LOCATION
      }/integrations/flipkartAds/auth?wsName=ipName=${ipName}&ipId=${ipId}&userId=${
        user.id
      }&companyId=${user.companyId}${
        storeName != "" ? "&storeName=" + storeName : ""
      }`;
      return;

    case IpNames.zepto:
      setRedirectObj();
      step != 2
        ? handleStep(
            user?.role == UserRole.Agency ? 11 : 10,
            setStep,
            ip,
            setIp
          )
        : [];
      return;
    case IpNames.myntra:
      setRedirectObj();
      step != 2
        ? handleStep(
            2,
            setStep,
            ip,
            setIp
          )
        : [];
      return;
    case IpNames.blinkitB2b:
      setRedirectObj();
      step != 2
        ? handleStep(
            user?.role == UserRole.Agency ? 11 : 10,
            setStep,
            ip,
            setIp
          )
        : [];
      return;
    case IpNames.swiggyInstamart:
      setRedirectObj();
      step != 2
        ? handleStep(
            user?.role == UserRole.Agency ? 11 : 10,
            setStep,
            ip,
            setIp
          )
        : [];
      return;
    case IpNames.blinkitMarketplace:
      setRedirectObj();
      step != 2
        ? handleStep(
            user?.role == UserRole.Agency ? 11 : 10,
            setStep,
            ip,
            setIp
          )
        : [];
      return;
    case IpNames.flipkartSeller:
      setRedirectObj();
      step != 2
        ? handleStep(
            user?.role == UserRole.Agency ? 11 : 10,
            setStep,
            ip,
            setIp
          )
        : [];
      return;
    case IpNames.nykaa:
      setRedirectObj();
      step != 2
        ? handleStep(
            user?.role == UserRole.Agency ? 11 : 10,
            setStep,
            ip,
            setIp
          )
        : [];
      return;
    case IpNames.blinkitAds:
      setRedirectObj();
      step != 2
        ? handleStep(
            user?.role == UserRole.Agency ? 11 : 10,
            setStep,
            ip,
            setIp
          )
        : [];
      return;
    default:
      return;
  }
}
